import React from 'react';
import { Link } from 'react-router-dom';
/* Components */
import Chat from '../components/chat/chat';
/* Assets */
import ArrowBack from '../assets/icons/arrow_back.svg';
import { useTranslation } from 'react-i18next';

const Coaching = () => {
  const { t } = useTranslation()
  return (
    <>
    <div className='back-button'>
      <Link to={'/'} className='back-button_arrow'><img src={ArrowBack} className='' alt='' />{t('back')}</Link>
      <span className='back_button_root'>Shaia /</span>
      <span className='back_button_page'>Sesión de coaching</span>
    </div>
    <Chat />
    </>
  );
}

export default Coaching;
